<template>
  <div class="Notification-fallback">
    <div class="Notification-fallbackGraphic">
      <svg>
        <use xlink:href="#Review" />
      </svg>
    </div>
    <h3>You have no review notifications</h3>
    <p>Recently saved reviews will appear here.</p>
    <img
      :src="image"
      alt="no jobs"
    >
    <p>Click on the star icon next to a review to save it. It’s an easy way to keep track of reviews you like.</p>
  </div>
</template>
<script>
import StarSearchHint from '../images/star-search-hint.png';

export default {
  data() {
    return {
      image: StarSearchHint,
    };
  },
};
</script>
